import { Component, OnInit } from '@angular/core';
import { UnsubscribeService } from "app/unsubscribe-newsletter/unsubscribe.service";
import { NewsletterResource } from "app/models/NewsletterResource";
import { Params, ActivatedRoute } from '@angular/router';
import { MessageService } from "app/message-service.service";
import { TranslateService } from "@ngx-translate/core";
import { environment } from 'environments/environment';

@Component({
  selector: 'vbn-unsubscribe-newsletter',
  providers: [UnsubscribeService],
  templateUrl: './unsubscribe-newsletter.component.html',
  styleUrls: ['./unsubscribe-newsletter.component.scss']
})
export class UnsubscribeNewsletterComponent implements OnInit {

  errorMessage: any;
  newsletterResource: NewsletterResource
  params: any
  email: any
  languageMail: any
  error: boolean = false;
  language = localStorage.getItem("vbn-language");
  showUnsubMessage: boolean = true;
  showUnsubButton: boolean = false;
  userEmail = atob(localStorage.getItem("_user"));


  constructor(private unsubscribeService: UnsubscribeService, private route: ActivatedRoute, private translate: TranslateService,
        private messageService: MessageService) {
    this.newsletterResource = new NewsletterResource();
  }

  ngOnInit() {
    this.params = this.route.params.forEach((params: Params) => {
      this.email = JSON.parse(atob(params['email'])).userEmail
      console.log("--------------------adi----------------------", this.email)
      this.languageMail = JSON.parse(atob(params['email'])).languageMail
    })
    this.getNewsletter();
    this.changeLanguage(this.languageMail);
  }

  changeLanguage(language) {
            this.language = language;
            if (this.language == "ro") {
                localStorage.setItem("vbn-language", "ro"); 
                this.translate.use('ro')
                this.messageService.sendMessage({
                    type: "changedLanguage",
                    changedLanguage: this.language
                });
            } else {
                localStorage.setItem("vbn-language", "en");
                this.translate.use('en')
                this.messageService.sendMessage({
                    type: "changedLanguage",
                    changedLanguage: this.language
                });
            }
    }

  getNewsletter() {
    this.unsubscribeService.getNewsletter(`/admin/newsletter/getByEmail?email=` + this.email).subscribe(
      body => {
        this.newsletterResource = body;
        console.log("------------------", body)
        // if (body.errorCode === 7000) {
        //     this.showConfirmButton = false;
        //     this.done = true;
        //     this.unsubscribe = false;
        // }
      },
      error => {
      })
  }

  unsubscribeUser() {
    this.unsubscribeService.unsubscribe(`/admin/newsletter/delete?email=` + this.email+"&userEmail="+this.userEmail).subscribe(
      body => {
        this.newsletterResource = body;
        this.showUnsubMessage = false;
        this.showUnsubButton = true;
      },
      error => this.errorMessage = <any>error)
  }

}
